import { PiForkKnife, PiForkKnifeFill } from 'react-icons/pi'

/**
 * Notebook icon for the chain/doors "Menu" column. Renders both stroke and
 * fill variants; CSS in main.css scoped to .fb-plain-links toggles visibility
 * based on the parent row's hover state. Outside the DS2026 surface the stroke
 * variant shows by default.
 */
export function MenuIcon({
  size = 20,
  className = '',
}: {
  size?: number
  className?: string
}) {
  return (
    <span className="fb-menu-icon-wrap inline-flex">
      <PiForkKnife
        size={size}
        className={`fb-menu-icon-stroke ${className}`.trim()}
      />
      <PiForkKnifeFill
        size={size}
        className={`fb-menu-icon-fill ${className}`.trim()}
      />
    </span>
  )
}
